import * as React from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { ReserveOption as Presenter, IProps as IPresenter } from './presenter'

type IProps = Omit<IPresenter, 'isInitialized'>

export const ReserveOption = ({ ...props }: IProps): JSX.Element => {
  return <Presenter {...props} />
}
